// extracted by mini-css-extract-plugin
export default {"container":"CardFeature_container__T6G9s","container__svg":"CardFeature_container__svg__G5jug"};